export const initialState: ScannerState = {
  isEnabled: true
};

export interface ScannerState {
  isEnabled: boolean;
}


// WEBPACK FOOTER //
// ./src/components/scanner/state.ts